<h2 mat-dialog-title class="mb-0">{{ data.title | transloco }}</h2>
<div mat-dialog-content>
  <p>{{ data.message | transloco }}</p>
</div>
<div mat-dialog-actions align="end" class="mb-2">
  <button mat-button (click)="onNoClick()" >
    {{data.cancelText | transloco}}
  </button>
  <button mat-flat-button [mat-dialog-close]="true" color="primary" (click)="onConfirmClick()">
    {{data.confirmText | transloco}}
  </button>
</div>
